module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lightbox-gallery-slide', {
    staticClass: "lightbox-media-gallery-slide"
  }, [(_vm.media.type === 'image') ? _c('img', {
    staticClass: "media",
    attrs: {
      "src": _vm.media.url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.type === 'video') ? [(_vm.iframe) ? _c('div', {
    staticClass: "media media-fixed-ratio ratio-16-9",
    domProps: {
      "innerHTML": _vm._s(_vm.iframeHtml)
    }
  }) : _c('video', {
    staticClass: "media",
    attrs: {
      "src": _vm.media.url
    },
    on: {
      "error": _vm.onVideoError
    }
  })] : _vm._e(), _vm._v(" "), (_vm.media.type === 'iframe') ? _c('div', {
    staticClass: "media",
    domProps: {
      "innerHTML": _vm._s(_vm.media.html)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.type === 'sketchfab') ? _c('div', {
    staticClass: "media media-fixed-ratio ratio-16-9",
    domProps: {
      "innerHTML": _vm._s(_vm.iframeHtml)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.type === 'marmoset') ? _c('div', {
    staticClass: "media media-fixed-ratio ratio-8-6"
  }, [_c('marmoset-viewer', {
    attrs: {
      "src": _vm.media.url
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.media.type === 'error' || _vm.iframeError) ? _c('p', {
    staticClass: "media-error"
  }, [_vm._v("\n        " + _vm._s(_vm.media.message || _vm.iframeError) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.media.caption) ? _c('p', {
    staticClass: "media-caption"
  }, [_vm._v("\n        " + _vm._s(_vm.media.caption) + "\n    ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c4135bd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/lightbox/media-gallery-slide.vue
// module id = 2042
// module chunks = 2